
export default {
    CLOSE_ICON: require('../images/cancel.svg'),
    KLICKLY_LOGO: require('../images/klickly-logo-final.svg'),
    MINIMUM_STRIPE_AMOUNT: 0.5,
    DEFAULT_CREDITS_AMOUNT: 1000
};
